import Toast from '@/components/Toast';
import { isAndroid, isIos, isWeiXin } from './toolsNew';

type THrefs = Array<string>

/**
 * 
 * @param {*} ua 
 * @param {*} herf  需要的是数组 [androidHref, iosHref]
 */
const downloadFn = (ua: string, herfs: THrefs) => {
  const [ 
    androidHref = `${process.env.NEXT_PUBLIC_OPEN_ANDROID}/home.html`,
    iOSHref = `${process.env.NEXT_PUBLIC_OPEN_IOS}/home.html?download=1`
  ] = herfs;

  if (isIos(ua)) {
    if (isWeiXin(ua)) {
      setTimeout(() => {
        Toast('请点击浏览器右上角按钮，选择“在默认浏览器中打开”');
      }, 200);
    }
    window.location.href = iOSHref;
  } else if(isAndroid(ua)) {
    if(isWeiXin(ua)){
      Toast('即将为您跳转下载页面，请点击浏览器右上角按钮，选择“在默认浏览器中打开”');
      // return;
    }
    window.location.href = androidHref;
  }

  setTimeout(() => {
    window.location.href = `${process.env.NEXT_PUBLIC_API_PRO}/download`;
  }, 2000);
};
export default downloadFn;
